import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './styles/design-system.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Deployment trigger: Tue Aug 19 02:06:57 CDT 2025
